import { Pressable } from "react-native";
import { TouchableProps } from "./Touchabe.types";
import { useClassNames } from "../../../structure";

export default function Touchable({ classNames, children, onPress, touchedOpacity = 0.4, disabled }: TouchableProps) {
  const style = useClassNames(classNames);
  return (
    <Pressable
      disabled={disabled}
      style={({ pressed }) => ({ opacity: pressed ? touchedOpacity : 1, ...style })}
      onPress={onPress}
    >
      {children}
    </Pressable>
  );
}
